import {
  Circle,
  Highlighter,
  LineSquiggle,
  MoveUpRight,
  Square,
  type LucideIcon,
} from 'lucide-react';
import { i18n } from '@/shared/i18n';
import type { AnnotationTool } from '../model/annotation';

export interface ToolSpec {
  tool: AnnotationTool;
  label: string;
  Icon: LucideIcon;
}

// Getters, not values: these specs are built while the module is evaluated, so resolving per
// read is what lets a label follow a language change instead of freezing at import.
const CIRCLE: ToolSpec = {
  tool: 'circle',
  get label() {
    return i18n.t('projects:commentOnFile.toolSpecs.circle');
  },
  Icon: Circle,
};
const RECTANGLE: ToolSpec = {
  tool: 'rectangle',
  get label() {
    return i18n.t('projects:commentOnFile.toolSpecs.square');
  },
  Icon: Square,
};
const PEN: ToolSpec = {
  tool: 'pen',
  get label() {
    return i18n.t('projects:commentOnFile.toolSpecs.draw');
  },
  Icon: LineSquiggle,
};
const ARROW: ToolSpec = {
  tool: 'arrow',
  get label() {
    return i18n.t('projects:commentOnFile.toolSpecs.arrow');
  },
  Icon: MoveUpRight,
};
const TEXT_HIGHLIGHT: ToolSpec = {
  tool: 'text-highlight',
  get label() {
    return i18n.t('projects:commentOnFile.toolSpecs.textHighlight');
  },
  Icon: Highlighter,
};

export const BASE_TOOL_SPECS: readonly ToolSpec[] = [CIRCLE, RECTANGLE, PEN, ARROW];

export const PDF_TOOL_SPECS: readonly ToolSpec[] = [...BASE_TOOL_SPECS, TEXT_HIGHLIGHT];

export const TOOL_SPECS_BY_TOOL: Record<AnnotationTool, ToolSpec> = {
  circle: CIRCLE,
  rectangle: RECTANGLE,
  pen: PEN,
  arrow: ARROW,
  'text-highlight': TEXT_HIGHLIGHT,
};
